<h2 class="first_title">Impostazioni Utente</h2>
<div class="standardpanel">
  <!-- CAMBIO PASSWORD -->
  <ng-container *ngIf="canUserChangePassword && canUserChangePassword === 'true'">
    <div class="titleblock">
      <h3 class="title1level">Cambio Password</h3>
    </div>
    <div class="container_dati_generali">
      <div class="row">
        <div class="col-sm-12 coldx">
          <form [formGroup]="changePwdForm" (ngSubmit)="save();">
            <div class="row">
              <p class="form-group col-xs-6 col-sm-6">
                <label for="currentPwd">Password corrente</label>
                  <input type="password" autocomplete="off" id="currentPwd" name="currentPwd" formControlName="currentPwd" 
                    class="form-control" placeholder="Password corrente" />                
              </p>
                <div *ngIf="currentPwd.errors && (currentPwd.dirty || currentPwd.touched) " class="alert alert-danger">
                  <div *ngIf="currentPwd.errors.required">
                      La password corrente è obbligatoria.
                  </div>
                </div>
            </div>

            <div class="row">
              <p class="form-group col-xs-6 col-sm-6">
                <label for="newPwd">Nuova password</label>
                  <input type="password" autocomplete="off" id="newPwd" name="newPwd" formControlName="newPwd" class="form-control" placeholder="Nuova Password" />
              </p>
              <div class="alert alert-danger" *ngIf="newPwd.errors && (newPwd.dirty || newPwd.touched) "> 
                <div *ngIf="newPwd.errors.required">
                  La nuova password è obbligatoria.
                </div>
                <div *ngIf="newPwd.errors.newIsNotOld">
                  La nuova password non può essere la stessa della password corrente.
                </div>            
              </div>
            </div>

            <div class="row">
              <p class="form-group col-xs-6 col-sm-6">
                <label for="confirmPwd">Conferma nuova password</label>
                  <input id="confirmPwd" name="confirmPwd" formControlName="confirmPwd" type="password" class="form-control" placeholder="Conferma nuova password" />
              </p>
              <div class="alert alert-danger" *ngIf="confirmPwd.errors && (confirmPwd.dirty || confirmPwd.touched) "> 
                <div *ngIf="confirmPwd.errors.required">
                  La conferma della password è obbligatoria.
                </div>
                <div *ngIf="confirmPwd.errors.newMatchesConfirm">
                  Le due password non corrispondono
                </div>            
              </div>
            </div>

            <div class="row">
              <p submitButton class="col-sm-3 col-xs-6" [disabled]="!changePwdForm.valid"
                [labelButton]="'Cambio password'"
              >
            </div>
            <label id="msg" *ngIf="messageError">   
              <div class="alert alert-danger" role="alert">
                Si è verificato un errore nel cambio password
              </div>
            </label>
            <label id="msg" *ngIf="messageSuccess">   
              <div class="alert alert-success" role="alert">
                Cambio password effettuato correttamente
              </div>
            </label>   
          </form>
        </div>
      </div>
    </div>
  </ng-container>
   <!-- SCADENZARIO LISIA -->
  <div class="titleblock">
    <h3 class="title1level">File per scadenzario LISIA</h3>
    <p>
      <a href="javascript:void(0);"
        (click)="downloadCSV(downloadForm.value.startDate, downloadForm.value.endDate)"
        [class.disabled]="downloadForm.invalid"
        [attr.aria-disabled]="downloadForm.invalid">Scarica
        <span class="glyphicon glyphicon-save"></span>
      </a>
    </p>
  </div>
  <div class="container_dati_generali">
    <div class="row">
      <form [formGroup]="downloadForm">
        <div class="form-row">
          <div datePickerInput class="col-sm-6"
            [labelInput]="'Data inizio'"
            [mandatory]="true"
            formControlName="startDate"
            [control]="downloadForm.controls['startDate']"
            [dataAl]="downloadForm.controls['endDate'].value">
          </div>

          <div datePickerInput class="col-sm-6"
              [labelInput]="'Data fine'"
              [mandatory]="true"
              formControlName="endDate"
              [control]="downloadForm.controls['endDate']"
              [dataDal]="downloadForm.controls['startDate'].value">
          </div>
        </div>
        <div *ngIf="downloadForm.errors?.dateRangeInvalid" class="text-danger">
          La data di inizio non può essere successiva alla data di fine.
        </div>
      </form>
    </div>
  </div>
  
  <div class="container_dati_generali">
    <div class="row">
      <div class="col-sm-12 coldx">
      </div>
    </div>
  </div>
</div>